var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 0C4.70313 0 0.203125 4.5 0.203125 10C0.203125 15.5 4.70313 20 10.2031 20C15.7031 20 20.2031 15.5 20.2031 10C20.2031 4.5 15.7031 0 10.2031 0ZM8.20313 15L3.20313 10L5.02909 7.88598L8.20313 10.97L15.5084 3.98818L17.2031 6L8.20313 15Z",
    fill: "#00882D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.891f6243eb3159ab6ea908cec5b73a04.svg";
export { ForwardRef as ReactComponent };